import {Collapse, Fade} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions';
import React, {FunctionComponent} from 'react';

export interface FadedCollapseProps {
  in: boolean;
  children: any;
  CollapseProps?: Omit<TransitionProps, 'in'>;
  FadeProps?: Omit<TransitionProps, 'in'>;
}

const FadedCollapse: FunctionComponent<FadedCollapseProps> = ({
  children,
  in: visible,
  CollapseProps,
  FadeProps,
}: FadedCollapseProps) => (
  <Collapse in={visible} {...CollapseProps}>
    <Fade in={visible} {...FadeProps}>
      {children}
    </Fade>
  </Collapse>
);

export default FadedCollapse;
